import { all } from 'redux-saga/effects';

import loginSaga from './manageLoginSaga';

export default function* rootSaga() {
  yield all([loginSaga()]);
}
